"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _propTypes = require("prop-types");

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _Timeline = _interopRequireDefault(require("@material-ui/icons/Timeline"));

var _Layers = _interopRequireDefault(require("@material-ui/icons/Layers"));

var _Book = _interopRequireDefault(require("@material-ui/icons/Book"));

var _SandboxDrawerLayerSelector = _interopRequireDefault(require("./SandboxDrawerLayerSelector"));

var _SandboxDrawerVisualization = _interopRequireDefault(require("./SandboxDrawerVisualization"));

var _SandboxDrawerExplore = _interopRequireDefault(require("./SandboxDrawerExplore"));

var _Logo = _interopRequireDefault(require("../Logo/Logo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var menuOpen = (0, _core.css)("\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 78vh;\n  min-height: 640px;\n  width: 33%;\n  z-index: 5;\n  transition: 0.5s;\n  @media (max-width: 850px) {\n    width: 95%;\n    height: 78vh;\n    min-height: 590px;\n  }\n  @media (max-width: 500px) {\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 390px;\n  }\n");
var menuClosed = (0, _core.css)("\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 75vh;\n  width: 40px;\n  z-index: 5;\n  transition: 0.5s;\n  @media (max-width: 500px) {\n    flex-direction: column;\n    width: 100%;\n    height: 40px;\n  }\n");

var SandboxDrawer = function SandboxDrawer(props) {
  var data = props.data,
      onChange = props.onChange,
      selectedPackage = props.selectedPackage,
      selectedPackageDescription = props.selectedPackageDescription,
      toggleDialog = props.toggleDialog,
      toggleContributeDialog = props.toggleContributeDialog,
      toggleDrawer = props.toggleDrawer,
      toggleVisualization = props.toggleVisualization,
      toggleLayerSelector = props.toggleLayerSelector,
      toggleExplore = props.toggleExplore,
      drawerVisible = props.drawerVisible,
      drawerVisualization = props.drawerVisualization,
      drawerLayerSelector = props.drawerLayerSelector,
      drawerExplore = props.drawerExplore,
      foundationData = props.foundationData,
      allSlides = props.allSlides,
      updatePackage = props.updatePackage,
      foundationMapProps = props.foundationMapProps,
      areSlidesLoading = props.areSlidesLoading,
      errors = props.errors,
      updateSlideKey = props.updateSlideKey,
      selectedFoundationDatum = props.selectedFoundationDatum;
  var buttonStyle = (0, _core.css)("\n    color: #F3F2F3;\n    height: 40px;\n    opacity: 0.6;\n    display: flex;\n  ");
  var buttonIcon = (0, _core.css)("\n    margin: auto;\n  ");
  var on = (0, _core.css)("\n    opacity: 1;\n  ");
  var disabled = (0, _core.css)("\n    background: #AAA4AB;\n  ");
  var active = (0, _core.css)("\n    opacity: 1;\n    @media (min-width: 500px) {\n      border-left: 4px solid #201024;\n    }\n    @media (max-width: 500px) {\n      border-bottom: 4px solid #F3F2F3;\n      box-sizing: border-box;\n    }\n  ");
  var allVectorTileLayers = !areSlidesLoading && allSlides ? foundationData.every(function (slide) {
    return ["vtChoroplethMap", "vtScatterPlotMap"].includes(slide.mapType);
  }) : true;

  var nothing = function nothing() {};

  return (0, _core.jsx)("div", {
    css: drawerVisible ? menuOpen : menuClosed
  }, (0, _core.jsx)("div", null, (0, _core.jsx)("div", {
    css: (0, _core.css)("\n            text-transform: uppercase;\n            font-size: 1rem;\n            cursor: pointer;\n            background: #1E62BD;\n            color: #F3F2F3;\n            min-width: 40px;\n            text-align: center;\n            @media (max-width: 500px) {\n              display: grid;\n              grid-template-columns: repeat(4, auto);\n            }\n          ")
  }, (0, _core.jsx)("div", {
    onClick: toggleDrawer,
    onKeyPress: toggleDrawer,
    role: "button",
    tabIndex: 0,
    css: [buttonStyle, on]
  }, (0, _core.jsx)(_Menu["default"], {
    css: buttonIcon
  })), (0, _core.jsx)("div", {
    onClick: allVectorTileLayers ? nothing : toggleVisualization,
    onKeyPress: allVectorTileLayers ? nothing : toggleVisualization,
    role: "button",
    tabIndex: 0,
    css: [buttonStyle, drawerVisible && drawerVisualization && active, allVectorTileLayers && disabled]
  }, (0, _core.jsx)(_Timeline["default"], {
    css: buttonIcon
  })), (0, _core.jsx)("div", {
    onClick: toggleLayerSelector,
    onKeyPress: toggleLayerSelector,
    role: "button",
    tabIndex: 0,
    css: [buttonStyle, drawerVisible && drawerLayerSelector && active]
  }, (0, _core.jsx)(_Layers["default"], {
    css: buttonIcon
  })), (0, _core.jsx)("div", {
    onClick: toggleExplore,
    onKeyPress: toggleExplore,
    role: "button",
    tabIndex: 0,
    css: [buttonStyle, drawerVisible && drawerExplore && active]
  }, (0, _core.jsx)(_Book["default"], {
    css: buttonIcon
  })))), drawerVisible && (0, _core.jsx)("div", {
    css: (0, _core.css)("\n          background: rgba(255,255,255,0.9);\n          overflow-y: auto;\n            box-shadow: -10px 5px 15px -3px rgba(0, 0, 0, 0.2);\n            flex-grow: 2;\n        ")
  }, (0, _core.jsx)("div", {
    onClick: toggleDialog,
    onKeyPress: toggleDialog,
    role: "button",
    tabIndex: 0,
    css: (0, _core.css)("\n              display: flex;\n              background-color: #201024;\n              color: white;\n              height: 50px;\n              text-align: center;\n              cursor: pointer;\n              position: sticky;\n              top: 0;\n              z-index: 999;\n          ")
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)("margin: auto; padding-top: 5px;")
  }, (0, _core.jsx)(_Logo["default"], {
    type: "sandboxLogoInverted"
  }))), drawerVisualization && (0, _core.jsx)(_SandboxDrawerVisualization["default"], {
    selectedPackage: selectedPackage,
    selectedPackageDescription: selectedPackageDescription,
    selectedFoundationDatum: selectedFoundationDatum
  }), drawerLayerSelector && (0, _core.jsx)(_SandboxDrawerLayerSelector["default"], {
    data: data,
    onChange: onChange,
    selectedPackage: selectedPackage,
    foundationData: foundationData,
    allSlides: allSlides,
    updatePackage: updatePackage,
    foundationMapProps: foundationMapProps,
    areSlidesLoading: areSlidesLoading,
    errors: errors,
    updateSlideKey: updateSlideKey,
    toggleDrawer: toggleDrawer
  }), drawerExplore && (0, _core.jsx)(_SandboxDrawerExplore["default"], {
    data: data,
    selectedPackage: selectedPackage,
    updatePackage: updatePackage,
    errors: errors,
    toggleLayerSelector: toggleLayerSelector,
    toggleContributeDialog: toggleContributeDialog
  })));
};

var _default = SandboxDrawer;
exports["default"] = _default;
SandboxDrawer.propTypes = {
  data: (0, _propTypes.shape)({}),
  onChange: _propTypes.func,
  selectedPackage: _propTypes.string,
  selectedPackageDescription: _propTypes.string,
  toggleDialog: _propTypes.func,
  toggleDrawer: _propTypes.func,
  toggleContributeDialog: _propTypes.func,
  toggleVisualization: _propTypes.func,
  toggleLayerSelector: _propTypes.func,
  toggleExplore: _propTypes.func,
  drawerVisible: _propTypes.bool,
  drawerVisualization: _propTypes.bool,
  drawerLayerSelector: _propTypes.bool,
  drawerExplore: _propTypes.bool,
  foundationData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  allSlides: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  updatePackage: _propTypes.func,
  foundationMapProps: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  areSlidesLoading: _propTypes.bool,
  errors: _propTypes.bool,
  updateSlideKey: _propTypes.func,
  selectedFoundationDatum: (0, _propTypes.shape)({})
};